var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-flex',{staticClass:"spacetop"},[_c('v-card',[_c('v-card-text',{staticClass:"notfound"},[_vm._v("iPhone device, iOS 12 version or greater!")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }